import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface GenerarOtpRequest {
  mail: string;
  celular: string;
}

export interface GenerarOtpResponse {
  codigo_otp: string;
  errorBean: {
    codigo: string;
    descripcion: string;
  };
}

export interface ValidarOtpRequest {
  mail: string;
  celular: string;
  codigo: string;
}

export interface ValidarOtpResponse {
  codigoRespuesta: number;
  mensaje: string;
  respuesta: any;
  jsonRespuesta: any;
}

export interface BackendErrorResponse {
  error: string;
  message: string;
  status: number;
  timestamp: number;
}

export interface OtpState {
  mail: string;
  celular: string;
  otpSolicitado: boolean;
  tiempoInicio: number;
  contadorReenvios: number;
  intentosFallidos: number;
  otpBloqueado: boolean;
  otpExpirado: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  private readonly baseUrl = environment.HOST;

  constructor(private http: HttpClient) {}

  generarOtp(mail: string, celular: string): Observable<GenerarOtpResponse> {
    const request: GenerarOtpRequest = { mail: mail.trim(), celular: celular.trim() };
    return this.http.post<GenerarOtpResponse>(
      this.baseUrl + URL_MAP.API.OTP_GENERAR,
      request
    );
  }

  validarOtp(mail: string, celular: string, codigo: string): Observable<ValidarOtpResponse> {
    const request: ValidarOtpRequest = {
      mail: mail.trim(),
      celular: celular.trim(),
      codigo: codigo.trim()
    };
    return this.http.post<ValidarOtpResponse>(
      this.baseUrl + URL_MAP.API.OTP_VALIDAR,
      request
    );
  }
}
